import { HeroFeature } from "../interfaces/hero-feature.interface";

export const HERO_FEATURES: HeroFeature[] = [
    {
        icon: 'science',
        title: 'Advanced Laboratory Management',
        description: 'Comprehensive study tracking & analysis',
        detailedDescription: 'Monitor chemical studies, track research progress, manage sample inventories, and generate detailed analytical reports with real-time laboratory workflow optimization.'
    },
    {
        icon: 'inventory_2',
        title: 'Smart Inventory Control',
        description: 'Real-time chemical stock monitoring',
        detailedDescription: 'Advanced inventory tracking with automated reorder alerts, chemical compatibility checks, safety data management, and comprehensive audit trails for regulatory compliance.'
    },
    {
        icon: 'local_shipping',
        title: 'Integrated Shipping & BOL',
        description: 'Complete logistics & documentation',
        detailedDescription: 'Streamlined bill of lading management, automated shipping documentation, real-time tracking, and seamless integration with transportation partners and regulatory systems.'
    },
    {
        icon: 'analytics',
        title: 'Intelligent Analytics & Reports',
        description: 'Data-driven operational insights',
        detailedDescription: 'Advanced analytics dashboards with predictive insights, customizable reports, performance metrics, and AI-powered recommendations for operational optimization.'
    }
];